import type { SheetPolylineGeometry } from "building-types/views/sheetGeometryTypes";
import { sheetPolylineGeometryNew } from "building-types/views/sheetGeometryTypes";
import { percentNew } from "common/utils/nominalNumbers";
import { polyLine2Move, polyLine2Rotate } from "geom/polyLine2";
import { polyLine2New } from "geom/polyLine2Types";
import type { Vec2 } from "geom/vec2";

interface ArrowheadProps {
  readonly position: Vec2;
  readonly rotationRads: number;
  readonly width: number;
  readonly height: number;
  readonly strokeOpacity: number;
}

const arrowheadDefault: ArrowheadProps = {
  position: [0, 0],
  rotationRads: 0,
  width: 0.06,
  height: 0.07,
  strokeOpacity: 1,
};

/**
 * Generates arrowhead geometry for annotation leaders
 * @param props - Arrowhead configuration
 * @returns SheetGeometry containing the arrowhead polyline
 */
export function generateArrowheadGeometry(props: Partial<ArrowheadProps>): SheetPolylineGeometry {
  const resolvedProps = { ...arrowheadDefault, ...props };
  const { position, rotationRads, width, height } = resolvedProps;

  // Define arrowhead shape (pointing upward by default)
  let arrowheadShape = polyLine2New([
    -width / 2,
    -height, // Left wing tip
    0,
    0, // Center point
    width / 2,
    -height, // Right wing tip
    -width / 2,
    -height, // Close the shape
  ]);

  arrowheadShape = polyLine2Rotate(arrowheadShape, rotationRads);
  arrowheadShape = polyLine2Move(arrowheadShape, position[0], position[1]);

  return sheetPolylineGeometryNew({
    paths: [arrowheadShape],
    fill: true,
    fillOpacity: percentNew(1),
    strokeOpacity: percentNew(resolvedProps.strokeOpacity),
  });
}
